import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Skills from './pages/Skills';
import Services from './pages/Services';
import Contact from './pages/Contact';
import ProjectDetail from './pages/ProjectDetail';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Layout data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/skills" element={<Skills data-id="element-10" />} data-id="element-9" />
          <Route path="/services" element={<Services data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
          <Route path="/projects/:projectId" element={<ProjectDetail data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}
export default AppRouter;